import { writable } from 'svelte/store';


export let filterVehiclesQuery = writable<string>('');
export let filterVehiclesOnlyEnabled = writable<boolean>(false);